import React from 'react';
import { FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import { InputProps } from 'reactstrap/types/lib/Input';
import { useController } from 'react-hook-form';
import InputMask from 'react-input-mask';
import NumberPad from './NumberPad';

type Props = InputProps & {
  name: string;
  label?: string;
  valueDefault?: string;
};

const PhoneField = ({ name, label, valueDefault = '', ...props }: Props) => {
  const {
    field,
    fieldState: { invalid, error }
  } = useController({ name, defaultValue: valueDefault });

  const handleNumberClick = (num: string) => {
    if (field.value.length < 11) {
      field.onChange(String(field.value || '') + String(num));
    }
  };

  const handleDelete = () => {
    field.onChange(field.value.slice(0, -1));
  };

  return (
    <>
      <FormGroup>
        {label && <Label for={name}>{label}</Label>}
        <InputMask
          mask="(99) 99999-9999"
          {...field}
          {...props}
          readOnly
          value={field.value || ''}
        >
          {(inputProps) => (
            <Input {...inputProps} type="text" invalid={invalid} />
          )}
        </InputMask>
        {error && <FormFeedback>{error.message}</FormFeedback>}
      </FormGroup>
      <p className="small-text-number">(DDD) + celular</p>
      <NumberPad
        onNumberClick={handleNumberClick}
        onDelete={handleDelete}
        className="d-none d-md-block"
      />
    </>
  );
};

export default PhoneField;
